export default "__VITE_ASSET__DMQU2HkM__"